import React from "react";
import PublicHeader from "./PublicHeader";
export default function ReaderHeader() { return <PublicHeader />; }
